import { defineStore } from "pinia";
import { Campaign, emptyCampaign } from "~/entities/Campaign";
import type { ICampaignRepository, ICampaignSaveBody } from "~/interfaces/ICampaignRepository";
import { CampaignRepository } from "~/repositories/CampaignRepository";
import type { CampaignResponse } from "~/entities/CampaignResponse";

/**
 * キャンペインを扱うクラス
 */
export const useCampaignStore = defineStore("CampaignStore", () => {
  const campaignResponse = ref<CampaignResponse>();
  const selectedCampaign = ref<Campaign>(emptyCampaign());
  const loading = ref(false);

  const repository: ICampaignRepository = new CampaignRepository();

  const getCampaigns = async (options: Record<string, any>) => {
    loading.value = true;
    try {
      campaignResponse.value = await repository.getCampaigns(options);
      loading.value = false;
    } catch (error: any) {
      loading.value = false;
    }
  };

  const getCampaignHistory = async (campaignId: string) => {
    return await repository.getCampaignHistory(campaignId);
  };

  const createCampaign = async (campaign: ICampaignSaveBody) => {
    await repository.createCampaign(campaign);
  };

  const updateCampaign = async (campaignId: string, body: ICampaignSaveBody) => {
    await repository.updateCampaign(campaignId, body);
  };

  const deleteCampaign = async (campaignId: string) => {
    return await repository.deleteCampaign(campaignId);
  };

  return {
    loading,
    selectedCampaign,
    campaignResponse,
    getCampaigns,
    getCampaignHistory,
    createCampaign,
    updateCampaign,
    deleteCampaign,
  };
});
